export const STATUS_PAYMENT_METHOD_ACCEPTED = 0
export const STATUS_PAYMENT_METHOD_REJECTED = 1
export const STATUS_PAYMENT_METHOD_NOT_READY_YET = 2
